import { Controller } from '@hotwired/stimulus'

// Pricing — top-level section tabs (T1.10).
//
// Click one of the three tabs (For Dealers / Data & Tools / Add-ons) and
// only that section stays visible — the other two sections are hidden
// with the `hidden` attribute. No scroll, no anchor navigation.
//
// Markup contract:
//   <nav data-controller="pricing-tabs">
//     <a href="#dealers" data-pricing-tabs-target="tab"
//        data-action="click->pricing-tabs#click">For Dealers</a>
//     ...
//   </nav>
//   <section id="dealers">...</section>
//   <section id="data">...</section>
//   <section id="addons">...</section>
export default class extends Controller {
  static targets = ['tab']

  connect() {
    if (!this.hasTabTarget) return
    this._sections = this.tabTargets
      .map((tab) => document.getElementById(tab.getAttribute('href').slice(1)))
      .filter(Boolean)
    if (!this._sections.length) return

    const initial =
      this.tabTargets.find((t) => t.getAttribute('aria-selected') === 'true') ||
      this.tabTargets[0]
    this._setActive(initial.getAttribute('href').slice(1))
  }

  click(event) {
    event.preventDefault()
    const id = event.currentTarget.getAttribute('href').slice(1)
    this._setActive(id)
  }

  _setActive(id) {
    this.tabTargets.forEach((tab) => {
      const active = tab.getAttribute('href') === `#${id}`
      tab.classList.toggle('is-active', active)
      tab.setAttribute('aria-selected', active ? 'true' : 'false')
      tab.tabIndex = active ? 0 : -1
    })
    this._sections.forEach((section) => {
      section.hidden = section.id !== id
    })
  }
}
